// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "use-input-limits") return "javascripts/" + chunkId + ".2ea452729c.js";
	if (chunkId === "use-intl-tel-input") return "javascripts/" + chunkId + ".dbf198c841.js";
	if (chunkId === "trix") return "javascripts/trix.e1dd2d31cc.js";
	if (chunkId === "use-tags") return "javascripts/" + chunkId + ".36895de64b.js";
	if (chunkId === "maplibre-gl") return "javascripts/" + chunkId + ".02dd50d3c5.js";
	// return url for filenames based on template
	return undefined;
};